import React, {
  ReactElement,
  useCallback,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";

import { Icon } from "semantic-ui-react";

import { History } from "history";

type TabPentaProps = {
  style?: React.CSSProperties;
  activeItemStyle?: React.CSSProperties;
  activeStyle?: React.CSSProperties;
  collapsible?: boolean;
  data?: TabItem[];
  disabled?: boolean;
  history?: History;
  itemStyle?: React.CSSProperties;
  level?: number;
  mobileScreen?: boolean;
  padding?: string;
  renderEmpty?: React.ReactElement | null;
  selectedTabIndex?: number;
  tabWidth?: string;
  topTab?: React.ReactElement;
  onChangeSelectedTabName?: (name: React.ReactElement | string, index: number) => void;
  onTabChange?: (index: number) => void;
};

type TabItem = {
  key: string;
  icon?: ReactElement | string | null;
  name: React.ReactElement | string;
  render: () => React.ReactElement;
};

interface TabPentaRef {
  changeTab: (index: number) => void;
  changeTabKey: (toKey: string, callback?: () => void) => void;
}

const TabPenta = React.forwardRef<TabPentaRef, TabPentaProps>((props, forwardedRef) => {
  const [selectedTabIndex, setSelectedTabIndex] = useState<number>(0);
  const [selectedTabName, setSelectedTabName] = useState<React.ReactElement | string>("");
  const [showTab, setShowTab] = useState<boolean>(false);
  const [isMenuCollapsed, setIsMenuCollapsed] = useState<boolean>(false);
  const activeItem = useRef<HTMLDivElement | null>(null);

  const callbackRef = useRef<(() => void) | null>(null);

  useImperativeHandle(forwardedRef, () => ({
    changeTab(index: number) {
      const tabKey = props.data?.[index]?.key || "";

      setSelectedTabIndex(index);
      setSelectedTabName(tabKey);
      props.onChangeSelectedTabName?.(tabKey, index);
    },
    changeTabKey(toKey: string, callback?: () => void) {
      const index = (props.data ?? []).findIndex((item: TabItem) => item.key === toKey);

      if (index === -1) {
        return;
      }

      console.log("setSelectedTabIndex:", index);

      if (callback) {
        if (selectedTabIndex === index) {
          callback();
        } else {
          callbackRef.current = callback; // Store callback in ref
        }
      }

      const tabKey = props.data?.[index]?.key || "";

      setSelectedTabIndex(index);
      setSelectedTabName(tabKey);
      props.onChangeSelectedTabName?.(tabKey, index);
    },
  }));

  // Trigger callback after selectedTabIndex changes
  useEffect(() => {
    console.log(selectedTabIndex);

    if (callbackRef.current) {
      callbackRef.current();
      callbackRef.current = null; // Clear the callback after execution
    }
  }, [selectedTabIndex]);

  useEffect(() => {
    if (typeof props.selectedTabIndex === "number" && Number.isInteger(props.selectedTabIndex)) {
      console.log(" 1", props.selectedTabIndex);

      const tabKey = props.data?.[props.selectedTabIndex]?.key || "";

      setSelectedTabIndex(props.selectedTabIndex);
      setSelectedTabName(tabKey);

      props.onChangeSelectedTabName?.(tabKey, props.selectedTabIndex);

      return;
    }

    if (props.history && props.history.location.pathname !== "/") {
      try {
        const keys = props.history.location.pathname.split("/");

        console.log(props.history.location.pathname);
        console.log(keys, keys.length, props.level);

        if (keys.length > (props.level ?? 0)) {
          const key = keys[props.level ?? 0];
          const index = (props.data ?? []).map((item: TabItem) => item.key).indexOf(key);

          console.log(" 2", index);

          if (index !== -1) {
            const tabKey = props.data?.[index]?.key || "";

            setSelectedTabIndex(index);
            setSelectedTabName(tabKey);

            props.onChangeSelectedTabName?.(tabKey, index);
          }
        }
      } catch (error) {
        console.log(error);
      }
    }
  }, []);

  useEffect(() => {
    // console.log('useEffect: rops.selectedTabIndex ', props.selectedTabIndex);
    // console.log('useEffect: rops.selectedTabIndex ', typeof props.selectedTabIndex);
    if (typeof props.selectedTabIndex === "number" && Number.isInteger(props.selectedTabIndex)) {
      // console.log(" 3 selectedTabIndex: ", selectedTabIndex)
      // console.log(" 3 props.selectedTabIndex: ", props.selectedTabIndex)
      setSelectedTabIndex(props.selectedTabIndex);
      setSelectedTabName(props.data?.[props.selectedTabIndex]?.key || "");
    }
  }, [props.selectedTabIndex]);

  useEffect(() => {
    if (selectedTabName && typeof selectedTabIndex === "number") {
      const key = props.data?.[selectedTabIndex]?.key || "";

      if (key !== selectedTabName) {
        const foundIndex = (props.data ?? []).findIndex((item) => item.key === selectedTabName);

        const index = foundIndex === -1 ? 0 : foundIndex;
        const tabKey = props.data?.[index]?.key || "";

        if (tabKey) {
          setSelectedTabIndex(index);
          setSelectedTabName(tabKey);
          props.onChangeSelectedTabName?.(selectedTabName, index);
        }
      }
    }
  }, [props.data]);

  const getTextContent = useCallback((name: React.ReactElement | string): string => {
    const extractText = (node: React.ReactNode): string => {
      if (typeof node === "string") {
        return node;
      }

      if (React.isValidElement(node)) {
        const children = React.Children.toArray((node.props as any).children);

        return children.map((child) => extractText(child)).join("");
      }

      return "";
    };

    return extractText(name).replaceAll(/\d+/g, "");
  }, []);

  const getFirstChar = useCallback((text: string) => {
    // หาพยัชนะไทยตัวแรกในข้อความ (ก-ฮ)
    // ถ้าไม่เจอ ให้ใช้ตัวอักษรแรกแล้วแปลงเป็นตัวพิมพ์ใหญ่
    const match = /[\u0E01-\u0E2E]/.exec(text);

    return match ? match[0] : text.charAt(0).toUpperCase();
  }, []);

  const getDisplayContent = useCallback(
    (item: TabItem) => {
      if (!isMenuCollapsed) {
        return <>{item.name}</>;
      }

      if (item.icon) {
        return typeof item.icon === "string" ? (
          <img style={{ width: "20px" }} alt="menu.icon" src={item.icon} />
        ) : (
          item.icon
        );
      }

      return <>{getFirstChar(getTextContent(item.name))}</>;
    },
    [isMenuCollapsed]
  );

  const menuWidth: string = props.tabWidth || "250px";
  const collapsedWidth = "50px";
  const currentMenuWidth: string = isMenuCollapsed ? collapsedWidth : menuWidth;

  return (
    <div
      id="TabPenta"
      style={{
        display: "flex",
        flexDirection: props.mobileScreen ? "column" : "row",
        ...(props.mobileScreen ? { overflow: "scroll" } : { height: "100%" }),
        width: "100%",
      }}
    >
      <div
        style={{
          border: "solid #cccccc 1px",
          display: "flex",
          flexDirection: "column",
          maxHeight: "95vh",
          overflow: "hidden",
          transition: "width 0.075s ease, max-width 0.075s ease, min-width 0.075s ease",
          ...(props.mobileScreen
            ? { width: "100%" }
            : { maxWidth: currentMenuWidth, minWidth: currentMenuWidth }),
          ...props.style,
        }}
      >
        {props.collapsible && (
          <div
            style={{
              borderBottom: "1px solid #cccccc",
              color: "var(--primary-theme-color)",
              cursor: "pointer",
              display: "flex",
              justifyContent: isMenuCollapsed ? "center" : "",
              padding: "3px 12px",
            }}
            onClick={() => {
              setIsMenuCollapsed(!isMenuCollapsed);
            }}
          >
            <div
              style={{
                borderBottomWidth: "1px",
                borderColor: "var(--primary-theme-color)",
                borderRadius: "4px",
                borderStyle: "solid",
                borderTopWidth: "1px",
                width: "23px",
                ...(isMenuCollapsed
                  ? { borderLeftWidth: "1px", borderRightWidth: "3px", paddingLeft: "2px" }
                  : { borderLeftWidth: "3px", borderRightWidth: "1px" }),
              }}
            >
              <Icon name={isMenuCollapsed ? "angle right" : "angle left"} />
            </div>
          </div>
        )}

        <div
          style={{
            flex: 1,
            overflowX: "hidden",
            overflowY: "auto",
          }}
        >
          {[
            ...(props.topTab ? [props.topTab] : []),
            ...(props.data ?? []).map(
              (item: TabItem, index: number) => { 
                // console.log("TabPenta item", item)
                // console.log("TabPenta index", index)
                return (!props.mobileScreen || showTab || selectedTabIndex === index) && (
                  <div
                    key={item.key}
                    ref={props.data?.[selectedTabIndex]?.key === item.key ? activeItem : null}
                    id={`tab-${item.key}`}
                    className={props.data?.[selectedTabIndex]?.key === item.key ? "active" : ""}
                    style={{
                      ...(props.data?.[selectedTabIndex]?.key === item.key
                        ? {
                            backgroundColor: "var(--primary-select-background)",
                            ...props.activeStyle,
                          }
                        : { backgroundColor: "white" }),
                      alignItems: "center",
                      cursor: "pointer",
                      display: "flex",
                      justifyContent: isMenuCollapsed ? "center" : "flex-start",
                      minHeight: "30px",
                      padding: props.padding || "5px",
                      ...props.itemStyle,
                    }}
                    title={isMenuCollapsed ? getTextContent(item.name) : ""}
                    onClick={() => {
                      if (props.disabled) {
                        return;
                      }

                      if (props.mobileScreen) {
                        setShowTab(!showTab);
                      }

                      const tabKey = props.data?.[index]?.key || "";

                      setSelectedTabIndex(index);
                      setSelectedTabName(tabKey);
                      props.onChangeSelectedTabName?.(tabKey, index);

                      if (props.history && props.data) {
                        try {
                          const keys = props.history.location.pathname.split("/");

                          if (keys.length > (props.level ?? 0)) {
                            keys[props.level ?? 0] = props.data[index].key;
                            keys.splice((props.level ?? 0) + 1);
                            props.history.push(keys.join("/") + globalThis.location.search);
                          } else if (keys.length === (props.level ?? 0)) {
                            keys.push(props.data[index].key);
                            props.history.push(keys.join("/") + globalThis.location.search);
                          }
                        } catch (error) {
                          console.log(error);
                        }
                      }

                      props.onTabChange?.(index);
                    }}
                  >
                    <span
                      style={{
                        ...(props.data?.[selectedTabIndex]?.key === item.key
                          ? { color: "black", ...props.activeItemStyle }
                          : { color: "var(--primary-theme-color-dark)" }),
                        width: "100%",
                        ...(isMenuCollapsed && {
                          alignItems: "center",
                          display: "flex",
                          justifyContent: "center",
                        }),
                      }}
                    >
                      {getDisplayContent(item)}
                    </span>
                  </div>
                )
              }
             
            ),
          ]}
        </div>
      </div>
      <div
        style={{
          flex: 1,
          width: `calc(100% - ${currentMenuWidth})`,
        }}
      >
        {props.data?.[selectedTabIndex]?.render() ?? ""}
        {!!props.renderEmpty && (props.data ?? []).length === 0 && props.renderEmpty}
      </div>
    </div>
  );
});

TabPenta.displayName = "TabPenta";

export default TabPenta;
